import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AddRequestModal from '../../Home/Components/AddRequestModal';
import RequestElement from './RequestElement';
import api from '../../api/api';

const RequestList = () => {
  const [searchParams] = useSearchParams();
  const statusFilter = searchParams.get("status");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingRequest, setEditingRequest] = useState(null);
  const [requests, setRequests] = useState([]);
  const [viewingRequest, setViewingRequest] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchRequests = async () => {
    try {
      const res = await api.get('/requests/');
      setRequests(res.data);
    } catch (error) {
      console.error('Error fetching requests:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const filteredRequests = statusFilter 
    ? requests.filter(r => r.status === statusFilter) 
    : requests;

  const handleEdit = (req) => {
    setEditingRequest(req);
    setIsModalOpen(true);
  };

  const handleSave = async (data) => {
    try {
      if (data.id) {
        await api.put(`/requests/${data.id}/`, data);
      } else {
        await api.post('/requests/', data);
      }
      fetchRequests();
      setIsModalOpen(false);
      setEditingRequest(null);
    } catch (error) {
      console.error('Error saving request:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('آیا از حذف این درخواست مطمئن هستید؟')) {
      try {
        await api.delete(`/requests/${id}/`);
        fetchRequests();
      } catch (error) {
        console.error('Error deleting request:', error);
      }
    }
  };

  const respondToRequest = async (flowId, status, comment) => {
    try {
      await api.patch(`/request-flows/${flowId}/`, { status, comment: comment || '' });
      setViewingRequest(null);
      fetchRequests();
    } catch (error) {
      console.error('خطا در پاسخ به درخواست:', error);
      window.alert('خطا در ثبت پاسخ. دوباره تلاش کنید.');
    }
  };

  if (loading) return <div className="p-8 text-center">در حال بارگذاری...</div>;

  return (
    <div className="p-6 bg-slate-50 min-h-screen" dir="rtl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-xl font-bold text-slate-800">
          لیست درخواست‌ها {statusFilter && <span className="text-indigo-600">({statusFilter})</span>}
        </h1>
        <button 
          onClick={() => { setEditingRequest(null); setIsModalOpen(true); }}
          className="bg-indigo-600 text-white px-6 py-2 rounded-xl text-sm font-bold shadow-lg hover:bg-indigo-700 transition-all"
        >
          + افزودن
        </button>
      </div>

      <table className="w-full bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100">
        <thead className="bg-slate-50 text-slate-600 text-xs uppercase">
          <tr>
            <th className="p-4">ساعت</th>
            <th className="p-4">تاریخ</th>
            <th className="p-4">عنوان</th>
            <th className="p-4">توضیحات</th>
            <th className="p-4">وضعیت</th>
            <th className="p-4">عملیات</th>
          </tr>
        </thead>
        <tbody>
          {filteredRequests.map((req) => (
            <RequestElement 
              key={req.id} 
              {...req} 
              onEdit={() => handleEdit(req)} 
              onView={() => setViewingRequest(req)} 
              onDelete={() => handleDelete(req.id)}
            />
          ))}
        </tbody>
      </table>

      {isModalOpen && (
        <AddRequestModal 
          requestData={editingRequest}
          onClose={() => { setIsModalOpen(false); setEditingRequest(null); }} 
          onAdd={handleSave} 
        />
      )}

      {viewingRequest && (
        <AddRequestModal
          requestData={viewingRequest}
          respondMode={true}
          viewOnly={!viewingRequest.flows?.some((flow) => flow.status === 'pending')}
          onRespond={respondToRequest}
          onClose={() => setViewingRequest(null)}
        />
      )}
    </div>
  );
};

export default RequestList;